enum onBoarding {
  MOTHER_SHIPPER_DETAILS = 1,
  /*MOTHER_ACCOUNT_DETAILS = 3,
  BABY_ACCOUNT_DETAILS = 4,*/
  ACCOUNT_NUMBER = 3,
  /*DEFAULT_UNIT_OF_MEASUREMENT_DETAILS = 2,
  DEFAULT_CURRENCY = 5,
  DEFAULT_MANUFACTURING_COUNTRY = 6,
  DEFAULT_INCOTERM = 9,
  DEFAULT_SHIPMENT_WEIGHT = 10,*/
  OPTIONS = 5,
  PAPERLESS_TRADE = 7,
  MOTHER_INCOTERM = 8,
  IMAGE_PROPERTIES = 11,
  MOTHER_EXPORT_DECLARATION_DETAILS = 12,
  PACKAGING_CONFIGURATION = 13,
  TAX_SETTING = 14,
  EMAIL_CONFIGURATION = 15,
  MAWB_COUNTRY_CONFIGURATION = 16,
  INVOICE_CONFIGURATION = 17,
  CUSTOMER_CREDENTIAL = 18,
  ADDITIONAL_SERVICES = 19,
  BBX_CONFIGURATION = 20,
  LABEL_PRINT_CONFIGURATION = 21,
  BABY_DEFAULT_OPTIONS = 22,
  PICKUPS_DEFAULT_OPTIONS = 23,
  REPORT_CONFIG = 24,
  SAVE_RECIEVER_ADDRESS = 25,
  AUTO_PRINT_LABEL = 26,
  INDIVIDUAL_SHIPMENT_EXPORT_DECLARATION_DETAILS = 28,
}

const reportTypes = [
  { type: 'Pre-alert', value: 'PRE_ALERT_REPORT' },
  { type: 'Manifested Baby Shipment', value: 'MANIFESTED_REPORT' },
  { type: 'Closed Mother Shipment', value: 'CLOSED_MOTHER_SHIPMENT' },
  { type: 'Closed Mother Invoice', value: 'CI_REPORTS' },
  { type: 'Shipper Addresses', value: 'SHIPPER_ADDRESS' },
  { type: 'Receiver Addresses', value: 'RECEIVER_ADDRESS' },
  // { type: 'Summary Of Shipments', value: 'SHIPMENTS_SUMMARY' },
];

const reportFormat = [
  { type: 'Csv', value: 'csv' },
  { type: 'Excel', value: 'exl' },
  // { type: 'Pdf', value: 'pdf' },
];

const currencyValues = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EEK',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GHS',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LTL',
  'LVL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRU',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SLL',
  'SOS',
  'SRD',
  'STD',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XDR',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMW',
];

const inCoTerms = {
  EXW: 'ExWorks',
  FCA: 'Free Carrier',
  CPT: 'Carriage Paid To',
  CIP: 'Carriage and Insurance Paid To',
  DPU: 'Delivered at Place Unloaded',
  DAP: 'Delivered at Place',
  DDP: 'Delivered Duty Paid',
  FAS: 'Free Alongside Ship',
  FOB: 'Free on Board',
  CFR: 'Cost and Freight',
  CIF: 'Cost, Insurance and Freight',
  DDU: 'Delivered Duty Unpaid',
};

const incotermNames = {
  RC: ['FAS', 'FOB', 'FCA', 'EXW'],
  SC: ['DPU', 'Delivered at Terminal', 'CIP', 'CPT', 'CIF', 'CFR', 'DDU', 'DDP', 'DAP'],
};

const placesofIncotermList = {
  RC: 'Receiver City',
  SC: 'Shipper City',
};

const uoms = {
  imperial: '(IN/LB)',
  metric: '(KG/CM) ',
};

const paperTradeList = ['Yes', 'No'];

const exportReasonValues = [
  'permanent',
  'temporary',
  'return',
  'used_exhibition_goods_to_origin',
  'intercompany_use',
  'commercial_purpose_or_sale',
  'personal_belongings_or_personal_use',
  'sample',
  'gift',
  'return_to_origin',
  'warranty_replacement',
  'diplomatic_goods',
  'defence_material',
];

const exportInvoice = [
  {
    label: 'Create invoice using baby shipment information',
    value: 'Default',
  },
  {
    label: 'Use own invoice',
    value: 'Custom',
  },
];

const imageDocTemplates = {
  labelTypes: {
    'PDF A4': 'ECOM26_84_A4_001',
    'PDF 8x4': 'ECOM26_84_001',
    'PDF 6x4': 'ECOM26_A6_002',
  },
  labelTypesLbbx: {
    'PDF 8x4': 'ECOM26_84_LBBX_001',
    'PDF 6x4': 'ECOM26_64_LBBX_001',
  },
  wayBillTypes: {
    'PDF A4': 'ARCH_8X4_A4_002',
    'PDF 8x4': 'ARCH_8X4',
    'PDF 6x4': 'ARCH_6X4',
  },
  invoiceTypes: {
    commercial: 'COMMERCIAL_INVOICE_P_10',
    proforma: 'COMMERCIAL_INVOICE_P_10',
  },
  printerDpi: {
    dpi1: '200',
    dpi2: '300',
  },
  labelFormat: {
    format: 'pdf',
  },
};

const lineQuantityMisurements = [
  'BOX',
  '2GM',
  '2M',
  '2M3',
  '3M3',
  'M3',
  'DPR',
  'DOZ',
  '2NO',
  'PCS',
  'GM',
  'GRS',
  'KG',
  'L',
  'M',
  '3GM',
  '3L',
  'X',
  'NO',
  '2KG',
  'PRS',
  '2L',
  'CM2',
  '2M2',
  '3M2',
  'M2',
  '4M2',
  '3M',
  'CT',
  '3KG',
  'EA',
  'LBS',
  'RILL',
  'ROLL',
  'SET',
  'TU',
  'YDS',
  'CM',
  'CONE',
];

const lineItemReasonTypes = [
  'permanent',
  'temporary',
  'return',
  'used_exhibition_goods_to_origin',
  'intercompany_use',
  'commercial_purpose_or_sale',
  'personal_belongings_or_personal_use',
  'sample',
  'gift',
  'return_to_origin',
  'warranty_replacement',
  'diplomatic_goods',
  'defence_material',
];

const lineItemRefs = [
  'INB',
  'MAK',
  'ALX',
  'AFE',
  'PAN',
  'PON',
  'ABW',
  'SE',
  'SON',
  'OID',
  'DTC',
  'DTM',
  'DTQ',
  'DTR',
  'ITR',
  'MID',
  'OED',
  'OET',
  'OOR',
  'SME',
  'USM',
  'AAM',
  'CFR',
  'DOM',
  'FOR',
  'USG',
  'MAT',
  'NLR',
];

const countryReference = [
  {
    code: 'AF',
    name: 'AFGHANISTAN',
    isoCurrCd: 'USD',
    countryLocationType: 'C ',
    gmt: '+04:30',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'AL',
    name: 'ALBANIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'DZ',
    name: 'ALGERIA',
    isoCurrCd: 'DZD',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AS',
    name: 'AMERICAN SAMOA',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '−11:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AD',
    name: 'ANDORRA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AO',
    name: 'ANGOLA',
    isoCurrCd: 'AOA',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'AI',
    name: 'ANGUILLA',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '−04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'AG',
    name: 'ANTIGUA',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '−04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'AR',
    name: 'ARGENTINA',
    isoCurrCd: 'ARS',
    countryLocationType: 'CP',
    gmt: '-03:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AM',
    name: 'ARMENIA',
    isoCurrCd: 'AMD',
    countryLocationType: 'CP',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AW',
    name: 'ARUBA',
    isoCurrCd: 'AWG',
    countryLocationType: 'S ',
    gmt: '−04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'AU',
    name: 'AUSTRALIA',
    isoCurrCd: 'AUD',
    countryLocationType: 'CP',
    gmt: '+11:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AT',
    name: 'AUSTRIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AZ',
    name: 'AZERBAIJAN',
    isoCurrCd: 'AZN',
    countryLocationType: 'CP',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BS',
    name: 'BAHAMAS',
    isoCurrCd: 'BSD',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BH',
    name: 'BAHRAIN',
    isoCurrCd: 'BHD',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BD',
    name: 'BANGLADESH',
    isoCurrCd: 'BDT',
    countryLocationType: 'CP',
    gmt: '+06:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BB',
    name: 'BARBADOS',
    isoCurrCd: 'BBD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BY',
    name: 'BELARUS',
    isoCurrCd: 'BYN',
    countryLocationType: 'CP',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BE',
    name: 'BELGIUM',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BZ',
    name: 'BELIZE',
    isoCurrCd: 'BZD',
    countryLocationType: 'S ',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BJ',
    name: 'BENIN',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BM',
    name: 'BERMUDA',
    isoCurrCd: 'BMD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BT',
    name: 'BHUTAN',
    isoCurrCd: 'BTN',
    countryLocationType: 'C ',
    gmt: '+06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BO',
    name: 'BOLIVIA',
    isoCurrCd: 'BOB',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'XB',
    name: 'BONAIRE',
    isoCurrCd: 'EUR',
    countryLocationType: 'C ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BA',
    name: 'BOSNIA AND HERZEGOVINA',
    isoCurrCd: 'BAM',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BW',
    name: 'BOTSWANA',
    isoCurrCd: 'BWP',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BR',
    name: 'BRAZIL',
    isoCurrCd: 'BRL',
    countryLocationType: 'CP',
    gmt: '-02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BN',
    name: 'BRUNEI',
    isoCurrCd: 'BND',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BG',
    name: 'BULGARIA',
    isoCurrCd: 'BGN',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'BF',
    name: 'BURKINA FASO',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'BI',
    name: 'BURUNDI',
    isoCurrCd: 'BIF',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KH',
    name: 'CAMBODIA',
    isoCurrCd: 'KHR',
    countryLocationType: 'CP',
    gmt: '+07:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CM',
    name: 'CAMEROON',
    isoCurrCd: 'XAF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CA',
    name: 'CANADA',
    isoCurrCd: 'CAD',
    countryLocationType: 'CP',
    gmt: '-03:30',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'IC',
    name: 'CANARY ISLANDS, THE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'CV',
    name: 'CAPE VERDE',
    isoCurrCd: 'CVE',
    countryLocationType: 'C ',
    gmt: '-01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KY',
    name: 'CAYMAN ISLANDS',
    isoCurrCd: 'KYD',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CF',
    name: 'CENTRAL AFRICAN REPUBLIC',
    isoCurrCd: 'XAF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TD',
    name: 'CHAD',
    isoCurrCd: 'XAF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CL',
    name: 'CHILE',
    isoCurrCd: 'CLP',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CN',
    name: 'CHINA, PEOPLES REPUBLIC',
    isoCurrCd: 'CNY',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'CO',
    name: 'COLOMBIA',
    isoCurrCd: 'COP',
    countryLocationType: 'CP',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MP',
    name: 'COMMONWEALTH NO. MARIANA ISLANDS',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '+10:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'KM',
    name: 'COMOROS',
    isoCurrCd: 'EUR',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CG',
    name: 'CONGO',
    isoCurrCd: 'XAF',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CD',
    name: 'CONGO, THE DEMOCRATIC REPUBLIC OF',
    isoCurrCd: 'CDF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CK',
    name: 'COOK ISLANDS',
    isoCurrCd: 'NZD',
    countryLocationType: 'C ',
    gmt: '-11:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CR',
    name: 'COSTA RICA',
    isoCurrCd: 'CRC',
    countryLocationType: 'S ',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CI',
    name: 'COTE D IVOIRE',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'HR',
    name: 'CROATIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'CU',
    name: 'CUBA',
    isoCurrCd: 'CUC',
    countryLocationType: 'CP',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'XC',
    name: 'CURACAO',
    isoCurrCd: 'ANG',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'CY',
    name: 'CYPRUS',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+2:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'CZ',
    name: 'CZECH REPUBLIC, THE',
    isoCurrCd: 'CZK',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'DK',
    name: 'DENMARK',
    isoCurrCd: 'DKK',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'DJ',
    name: 'DJIBOUTI',
    isoCurrCd: 'DJF',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'DM',
    name: 'DOMINICA',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'DO',
    name: 'DOMINICAN REPUBLIC',
    isoCurrCd: 'DOP',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'EC',
    name: 'ECUADOR',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'EG',
    name: 'EGYPT',
    isoCurrCd: 'EGP',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SV',
    name: 'EL SALVADOR',
    isoCurrCd: 'USD',
    countryLocationType: 'S ',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'ER',
    name: 'ERITREA',
    isoCurrCd: 'ERN',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'EE',
    name: 'ESTONIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'ET',
    name: 'ETHIOPIA',
    isoCurrCd: 'ETB',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'FK',
    name: 'FALKLAND ISLANDS',
    isoCurrCd: 'GBP',
    countryLocationType: 'C ',
    gmt: '-03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'FO',
    name: 'FAROE ISLANDS',
    isoCurrCd: 'DKK',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'FJ',
    name: 'FIJI',
    isoCurrCd: 'FJD',
    countryLocationType: 'C ',
    gmt: '+12:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'FI',
    name: 'FINLAND',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'FR',
    name: 'FRANCE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GF',
    name: 'FRENCH GUYANA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GA',
    name: 'GABON',
    isoCurrCd: 'XAF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GM',
    name: 'GAMBIA',
    isoCurrCd: 'GMD',
    countryLocationType: 'C ',
    gmt: '+0:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GE',
    name: 'GEORGIA',
    isoCurrCd: 'GEL',
    countryLocationType: 'CP',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'DE',
    name: 'GERMANY',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GH',
    name: 'GHANA',
    isoCurrCd: 'GHS',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GI',
    name: 'GIBRALTAR',
    isoCurrCd: 'GBP',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'XG',
    name: 'GLOBAL MAIL BILLING',
    isoCurrCd: 'EUR',
    countryLocationType: 'P ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GR',
    name: 'GREECE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GL',
    name: 'GREENLAND',
    isoCurrCd: 'DKK',
    countryLocationType: 'CP',
    gmt: '-03:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GD',
    name: 'GRENADA',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GP',
    name: 'GUADELOUPE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GU',
    name: 'GUAM',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '+10:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GT',
    name: 'GUATEMALA',
    isoCurrCd: 'GTQ',
    countryLocationType: 'S ',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GG',
    name: 'GUERNSEY',
    isoCurrCd: 'GBP',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'GN',
    name: 'GUINEA REPUBLIC',
    isoCurrCd: 'GNF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GW',
    name: 'GUINEA-BISSAU',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GQ',
    name: 'GUINEA-EQUATORIAL',
    isoCurrCd: 'XAF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GY',
    name: 'GUYANA (BRITISH)',
    isoCurrCd: 'GYD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'HT',
    name: 'HAITI',
    isoCurrCd: 'HTG',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'HN',
    name: 'HONDURAS',
    isoCurrCd: 'HNL',
    countryLocationType: 'S ',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'HK',
    name: 'HONG KONG SAR, CHINA',
    isoCurrCd: 'HKD',
    countryLocationType: 'C ',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'HU',
    name: 'HUNGARY',
    isoCurrCd: 'HUF',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'IS',
    name: 'ICELAND',
    isoCurrCd: 'ISK',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'IN',
    name: 'INDIA',
    isoCurrCd: 'INR',
    countryLocationType: 'CP',
    gmt: '+05:30',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'ID',
    name: 'INDONESIA',
    isoCurrCd: 'IDR',
    countryLocationType: 'CP',
    gmt: '+07:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'IR',
    name: 'IRAN (ISLAMIC REPUBLIC OF)',
    isoCurrCd: 'IRR',
    countryLocationType: 'C ',
    gmt: '+03:30',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'IQ',
    name: 'IRAQ',
    isoCurrCd: 'USD',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'IE',
    name: 'IRELAND, REPUBLIC OF',
    isoCurrCd: 'EUR',
    countryLocationType: 'S ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'IL',
    name: 'ISRAEL',
    isoCurrCd: 'ILS',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'IT',
    name: 'ITALY',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'JM',
    name: 'JAMAICA',
    isoCurrCd: 'JMD',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'JP',
    name: 'JAPAN',
    isoCurrCd: 'JPY',
    countryLocationType: 'CP',
    gmt: '+09:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'JE',
    name: 'JERSEY',
    isoCurrCd: 'GBP',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'JO',
    name: 'JORDAN',
    isoCurrCd: 'JOD',
    countryLocationType: 'S ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KZ',
    name: 'KAZAKHSTAN',
    isoCurrCd: 'KZT',
    countryLocationType: 'CP',
    gmt: '+06:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'KE',
    name: 'KENYA',
    isoCurrCd: 'KES',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KI',
    name: 'KIRIBATI',
    isoCurrCd: 'AUD',
    countryLocationType: 'C ',
    gmt: '+12:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KR',
    name: 'KOREA, REPUBLIC OF (SOUTH K.)',
    isoCurrCd: 'KRW',
    countryLocationType: 'CP',
    gmt: '+09:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'KP',
    name: 'KOREA, THE D.P.R OF (NORTH K.)',
    isoCurrCd: 'KPW',
    countryLocationType: 'C ',
    gmt: '+09:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KV',
    name: 'KOSOVO',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'KW',
    name: 'KUWAIT',
    isoCurrCd: 'KWD',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KG',
    name: 'KYRGYZSTAN',
    isoCurrCd: 'KGS',
    countryLocationType: 'CP',
    gmt: '+06:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'LA',
    name: 'LAO PEOPLES DEMOCRATIC REPUBLIC',
    isoCurrCd: 'LAK',
    countryLocationType: 'C ',
    gmt: '+07:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'LV',
    name: 'LATVIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'LB',
    name: 'LEBANON',
    isoCurrCd: 'USD',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'LS',
    name: 'LESOTHO',
    isoCurrCd: 'LSL',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'LR',
    name: 'LIBERIA',
    isoCurrCd: 'LRD',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'LY',
    name: 'LIBYA',
    isoCurrCd: 'LYD',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'LI',
    name: 'LIECHTENSTEIN',
    isoCurrCd: 'CHF',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'LT',
    name: 'LITHUANIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'LU',
    name: 'LUXEMBOURG',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MO',
    name: 'MACAO SAR, CHINA',
    isoCurrCd: 'MOP',
    countryLocationType: 'C ',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MG',
    name: 'MADAGASCAR',
    isoCurrCd: 'MGA',
    countryLocationType: 'CP',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MW',
    name: 'MALAWI',
    isoCurrCd: 'MWK',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MY',
    name: 'MALAYSIA',
    isoCurrCd: 'MYR',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MV',
    name: 'MALDIVES',
    isoCurrCd: 'MVR',
    countryLocationType: 'CP',
    gmt: '+05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'ML',
    name: 'MALI',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MT',
    name: 'MALTA',
    isoCurrCd: 'EUR',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MH',
    name: 'MARSHALL ISLANDS',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '+12:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MQ',
    name: 'MARTINIQUE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MR',
    name: 'MAURITANIA',
    isoCurrCd: 'MRU',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MU',
    name: 'MAURITIUS',
    isoCurrCd: 'MUR',
    countryLocationType: 'C ',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'YT',
    name: 'MAYOTTE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MX',
    name: 'MEXICO',
    isoCurrCd: 'MXN',
    countryLocationType: 'CP',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'FM',
    name: 'MICRONESIA, FEDERATED STATES OF',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '+10:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MD',
    name: 'MOLDOVA, REPUBLIC OF',
    isoCurrCd: 'MDL',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MC',
    name: 'MONACO',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MN',
    name: 'MONGOLIA',
    isoCurrCd: 'MNT',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'ME',
    name: 'MONTENEGRO, REPUBLIC OF',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MS',
    name: 'MONTSERRAT',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MA',
    name: 'MOROCCO',
    isoCurrCd: 'MAD',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'MZ',
    name: 'MOZAMBIQUE',
    isoCurrCd: 'MZN',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MM',
    name: 'MYANMAR',
    isoCurrCd: 'MMK',
    countryLocationType: 'C ',
    gmt: '+06:30',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NA',
    name: 'NAMIBIA',
    isoCurrCd: 'NAD',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NR',
    name: 'NAURU, REPUBLIC OF',
    isoCurrCd: 'AUD',
    countryLocationType: 'C ',
    gmt: '+12:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NP',
    name: 'NEPAL',
    isoCurrCd: 'NPR',
    countryLocationType: 'C ',
    gmt: '+05:45',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NL',
    name: 'NETHERLANDS, THE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'XN',
    name: 'NEVIS',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NC',
    name: 'NEW CALEDONIA',
    isoCurrCd: 'XPF',
    countryLocationType: 'CP',
    gmt: '+11:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'NZ',
    name: 'NEW ZEALAND',
    isoCurrCd: 'NZD',
    countryLocationType: 'CP',
    gmt: '+12:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'NI',
    name: 'NICARAGUA',
    isoCurrCd: 'NIO',
    countryLocationType: 'S ',
    gmt: '-06:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NE',
    name: 'NIGER',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NG',
    name: 'NIGERIA',
    isoCurrCd: 'NGN',
    countryLocationType: 'C ',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'NU',
    name: 'NIUE',
    isoCurrCd: 'NZD',
    countryLocationType: 'C ',
    gmt: '-11:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'MK',
    name: 'NORTH MACEDONIA',
    isoCurrCd: 'MKD',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'NO',
    name: 'NORWAY',
    isoCurrCd: 'NOK',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'OM',
    name: 'OMAN',
    isoCurrCd: 'OMR',
    countryLocationType: 'C ',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'PK',
    name: 'PAKISTAN',
    isoCurrCd: 'PKR',
    countryLocationType: 'CP',
    gmt: '+05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'PW',
    name: 'PALAU',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '+09:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'PA',
    name: 'PANAMA',
    isoCurrCd: 'USD',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'PG',
    name: 'PAPUA NEW GUINEA',
    isoCurrCd: 'PGK',
    countryLocationType: 'CP',
    gmt: '+10:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'PY',
    name: 'PARAGUAY',
    isoCurrCd: 'PYG',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'PE',
    name: 'PERU',
    isoCurrCd: 'PEN',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'PH',
    name: 'PHILIPPINES, THE',
    isoCurrCd: 'PHP',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'PL',
    name: 'POLAND',
    isoCurrCd: 'PLN',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'PT',
    name: 'PORTUGAL',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'PR',
    name: 'PUERTO RICO',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'QA',
    name: 'QATAR',
    isoCurrCd: 'QAR',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'RE',
    name: 'REUNION, ISLAND OF',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'RO',
    name: 'ROMANIA',
    isoCurrCd: 'RON',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'RU',
    name: 'RUSSIAN FEDERATION, THE',
    isoCurrCd: 'RUB',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'RW',
    name: 'RWANDA',
    isoCurrCd: 'RWF',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SH',
    name: 'SAINT HELENA',
    isoCurrCd: 'SHP',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'WS',
    name: 'SAMOA',
    isoCurrCd: 'WST',
    countryLocationType: 'C ',
    gmt: '+13:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SM',
    name: 'SAN MARINO',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'ST',
    name: 'SAO TOME AND PRINCIPE',
    isoCurrCd: 'STN',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SA',
    name: 'SAUDI ARABIA',
    isoCurrCd: 'SAR',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SN',
    name: 'SENEGAL',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'RS',
    name: 'SERBIA, REPUBLIC OF',
    isoCurrCd: 'RSD',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SC',
    name: 'SEYCHELLES',
    isoCurrCd: 'SCR',
    countryLocationType: 'C ',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SL',
    name: 'SIERRA LEONE',
    isoCurrCd: 'SLE',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SG',
    name: 'SINGAPORE',
    isoCurrCd: 'SGD',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SK',
    name: 'SLOVAKIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SI',
    name: 'SLOVENIA',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SB',
    name: 'SOLOMON ISLANDS',
    isoCurrCd: 'SBD',
    countryLocationType: 'C ',
    gmt: '+11:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SO',
    name: 'SOMALIA',
    isoCurrCd: 'SOS',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'XS',
    name: 'SOMALILAND, REP OF (NORTH SOMALIA)',
    isoCurrCd: 'USD',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'ZA',
    name: 'SOUTH AFRICA',
    isoCurrCd: 'ZAR',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SS',
    name: 'SOUTH SUDAN',
    isoCurrCd: 'SSP',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'ES',
    name: 'SPAIN',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'LK',
    name: 'SRI LANKA',
    isoCurrCd: 'LKR',
    countryLocationType: 'CP',
    gmt: '+05:30',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'XY',
    name: 'ST. BARTHELEMY',
    isoCurrCd: 'ANG',
    countryLocationType: 'CP',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'XE',
    name: 'ST. EUSTATIUS',
    isoCurrCd: 'ANG',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'KN',
    name: 'ST. KITTS',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'LC',
    name: 'ST. LUCIA',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'XM',
    name: 'ST. MAARTEN',
    isoCurrCd: 'EUR',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'VC',
    name: 'ST. VINCENT',
    isoCurrCd: 'XCD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SD',
    name: 'SUDAN',
    isoCurrCd: 'SDG',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SR',
    name: 'SURINAME',
    isoCurrCd: 'SRD',
    countryLocationType: 'S ',
    gmt: '-03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'SZ',
    name: 'SWAZILAND',
    isoCurrCd: 'SZL',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SE',
    name: 'SWEDEN',
    isoCurrCd: 'SEK',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'CH',
    name: 'SWITZERLAND',
    isoCurrCd: 'CHF',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'SY',
    name: 'SYRIA',
    isoCurrCd: 'SYP',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'PF',
    name: 'TAHITI',
    isoCurrCd: 'XPF',
    countryLocationType: 'CP',
    gmt: '-10:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TW',
    name: 'TAIWAN',
    isoCurrCd: 'TWD',
    countryLocationType: 'CP',
    gmt: '+08:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TJ',
    name: 'TAJIKISTAN',
    isoCurrCd: 'TJS',
    countryLocationType: 'CP',
    gmt: '+05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TZ',
    name: 'TANZANIA',
    isoCurrCd: 'TZS',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TH',
    name: 'THAILAND',
    isoCurrCd: 'THB',
    countryLocationType: 'CP',
    gmt: '+07:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TL',
    name: 'TIMOR LESTE',
    isoCurrCd: 'USD',
    countryLocationType: 'C ',
    gmt: '+09:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TG',
    name: 'TOGO',
    isoCurrCd: 'XOF',
    countryLocationType: 'C ',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TO',
    name: 'TONGA',
    isoCurrCd: 'TOP',
    countryLocationType: 'C ',
    gmt: '+13:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TT',
    name: 'TRINIDAD AND TOBAGO',
    isoCurrCd: 'TTD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TN',
    name: 'TUNISIA',
    isoCurrCd: 'TND',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TR',
    name: 'TURKEY',
    isoCurrCd: 'TRY',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TM',
    name: 'TURKMENISTAN',
    isoCurrCd: 'TMT',
    countryLocationType: 'CP',
    gmt: '+05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'TC',
    name: 'TURKS AND CAICOS ISLANDS',
    isoCurrCd: 'USD',
    countryLocationType: 'S ',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'TV',
    name: 'TUVALU',
    isoCurrCd: 'AUD',
    countryLocationType: 'C ',
    gmt: '+12:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'UG',
    name: 'UGANDA',
    isoCurrCd: 'UGX',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'UA',
    name: 'UKRAINE',
    isoCurrCd: 'UAH',
    countryLocationType: 'CP',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'AE',
    name: 'UNITED ARAB EMIRATES',
    isoCurrCd: 'AED',
    countryLocationType: 'C ',
    gmt: '+04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'GB',
    name: 'UNITED KINGDOM',
    isoCurrCd: 'GBP',
    countryLocationType: 'CP',
    gmt: '+00:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'US',
    name: 'UNITED STATES OF AMERICA',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '-05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'UY',
    name: 'URUGUAY',
    isoCurrCd: 'UYU',
    countryLocationType: 'S ',
    gmt: '-03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'UZ',
    name: 'UZBEKISTAN',
    isoCurrCd: 'UZS',
    countryLocationType: 'CP',
    gmt: '+05:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'VU',
    name: 'VANUATU',
    isoCurrCd: 'VUV',
    countryLocationType: 'C ',
    gmt: '+11:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'VA',
    name: 'VATICAN CITY STATE',
    isoCurrCd: 'EUR',
    countryLocationType: 'CP',
    gmt: '+01:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'VE',
    name: 'VENEZUELA',
    isoCurrCd: 'VES',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'VN',
    name: 'VIETNAM',
    isoCurrCd: 'VND',
    countryLocationType: 'C ',
    gmt: '+07:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'VG',
    name: 'VIRGIN ISLANDS (BRITISH)',
    isoCurrCd: 'USD',
    countryLocationType: 'S ',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'VI',
    name: 'VIRGIN ISLANDS (US)',
    isoCurrCd: 'USD',
    countryLocationType: 'CP',
    gmt: '-04:00',
    isPostalCodeServiceAvailable: true,
  },
  {
    code: 'YE',
    name: 'YEMEN, REPUBLIC OF',
    isoCurrCd: 'YER',
    countryLocationType: 'C ',
    gmt: '+03:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'ZM',
    name: 'ZAMBIA',
    isoCurrCd: 'ZMW',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
  {
    code: 'ZW',
    name: 'ZIMBABWE',
    isoCurrCd: 'USD',
    countryLocationType: 'C ',
    gmt: '+02:00',
    isPostalCodeServiceAvailable: false,
  },
];

const fileUploadStatusDisplayedColumns: string[] = [
  'file_name',
  'upload_datetime',
  'user_id',
  'specifications_id',
  'status',
  'fileInfo',
];

const addressFileUploadStatusDisplayedColumns: string[] = [
  'file_name',
  'upload_datetime',
  'added_user_id',
  'address_status',
  'address_fileInfo',
];

const fileUploadTypeCodeDisplayedColumns: string[] = [
  'fileName',
  'uploadDatetime',
  'userId',
  'typeCode',
  'action',
];

const packageTypes = {
  '3BX': 'Box 3',
  '2BC': 'Box 2 (Cube)',
  '2BP': 'Box 2 (Flat)',
  CE1: 'Card Envelope',
  '7BX': 'Box 7',
  '6BX': 'Box 6',
  '4BX': 'Box 4',
  '2BX': 'Box 2 (Tablet)',
  '1CE': 'Card Envelope',
  WB1: '1 Wine Box',
  WB3: '3 Wine Box',
  XPD: 'Express Envelope',
  '8BX': 'Box 8 (Jumbo Large)',
  '5BX': 'Box 5 (Jumbo Small)',
  WB6: '6 Wine Box',
  TBL: 'Tube Large',
  TBS: 'Tube Small',
  WB2: '2 Wine Box',
};

const typeCode = [
  { code: 'CIN', value: 'Commercial Invoice' },
  { code: 'INV', value: 'Invoice' },
  { code: 'PNV', value: 'Proforma' },
  { code: 'COO', value: 'Certificate of Origin' },
  { code: 'NAF', value: 'Nafta Certificate of Origin' },
  { code: 'DCL', value: 'Custom Declaration' },
];

const addressType = ['SHIPPER', 'RECEIVER'];

const configurationPageList = [
  {
    title: 'Mother Shipper Details',
    _id: 1,
    config_id: 'mother_shipperdetails',
    group_id: 1,
    translate: 'configuration.onBoarding.motherShipperDetails',
  },
  {
    title: 'Mother Export Declaration Details',
    itemTitle: 'Default Unit of Measurement Details',
    _id: 2,
    config_id: 'default_unitofmeasurement',
    group_id: 12,
    translate: 'configuration.onBoarding.motherExportDeclarationDetails',
  },
  {
    title: 'Account Numbers',
    itemTitle: 'Mother Account Details',
    _id: 3,
    config_id: 'mother_accountnumbers',
    group_id: 3,
    group_title: 'Account Number',
    translate: 'configuration.onBoarding.accountNumbers',
  },
  {
    title: 'Account Numbers',
    itemTitle: 'Baby Account Details',
    _id: 4,
    config_id: 'baby_accountnumbers',
    group_id: 3,
    group_title: 'Account Number',
    translate: 'configuration.onBoarding.accountNumbers',
  },
  {
    title: 'Default Options',
    itemTitle: 'Default Currency',
    _id: 5,
    config_id: 'default_currency',
    group_id: 5,
    group_title: 'Options',
    translate: 'configuration.onBoarding.defaultOptions',
  },
  {
    title: 'Default Options',
    itemTitle: 'Default Manufacturing Country',
    _id: 6,
    config_id: 'default_countryofmanufacture',
    group_id: 5,
    group_title: 'Options',
    translate: 'configuration.onBoarding.defaultOptions',
  },
  {
    title: 'Default Options',
    itemTitle: 'Unit price Decimal Value',
    _id: 11,
    config_id: 'unitPriceDecimalPoints',
    group_id: 5,
    group_title: 'Options',
    translate: 'configuration.onBoarding.defaultOptions',
  },
  {
    title: 'PaperlessTrade',
    _id: 7,
    config_id: 'paperless-trade',
    group_id: 7,
    translate: 'configuration.onBoarding.paperlessTrade',
  },
  // { title: 'Mother Incoterm', _id: 8, config_id: 'mother_incoterm', group_id: 8 },
  {
    title: 'Default Options',
    itemTitle: 'Default Incoterm',
    _id: 9,
    config_id: 'default_incoterm',
    group_id: 5,
    group_title: 'Options',
    translate: 'configuration.onBoarding.defaultOptions',
  },
  {
    title: 'Default Options',
    itemTitle: 'Default Shipment Weight',
    _id: 10,
    config_id: 'default_weight',
    group_id: 5,
    group_title: 'Options',
    translate: 'configuration.onBoarding.defaultOptions',
  },
  {
    title: 'DHL Label Print Settings',
    itemTitle: 'Image Properties',
    _id: 11,
    config_id: 'output_imageproperties',
    group_id: 11,
    translate: 'configuration.onBoarding.dhlLabelPrintSettings',
  },
  {
    title: 'Mother Export Declaration Details',
    _id: 12,
    config_id: 'mother_exportdeclarationdetails',
    group_id: 12,
    translate: 'configuration.onBoarding.motherExportDeclarationDetails',
  },
  {
    title: 'Packaging Configuration',
    _id: 13,
    group_id: 13,
    config_id: 'packaging_types',
    translate: 'configuration.onBoarding.packagingConfiguration',
  },
  {
    title: 'Tax-Setting',
    _id: 14,
    config_id: ['shipper_tax_setting', 'receiver_tax_setting', 'importer_tax_setting'],
    group_id: 14,
    translate: 'configuration.onBoarding.taxSetting',
  },
  {
    title: 'Prealert Configuration',
    _id: 15,
    config_id: 'prealert_reportparams',
    group_id: 15,
    translate: 'configuration.onBoarding.preAlertConfiguration',
  },
  {
    title: 'MAWB Country Configuration',
    _id: 16,
    config_id: 'mother_baby_destcountry_mapping',
    group_id: 16,
    translate: 'configuration.onBoarding.mawbCountryConfiguration',
  },
  {
    title: 'Invoice Configuration',
    _id: 17,
    config_id: 'default_invoice_export',
    group_id: 17,
    translate: 'configuration.onBoarding.invoiceConfiguration',
  },
  {
    title: 'Customer Credential',
    _id: 18,
    config_id: 'customer_credential',
    group_id: 18,
    translate: 'configuration.onBoarding.customerCredential',
  },
  {
    title: 'Additional Services',
    _id: 19,
    config_id: 'additional_services',
    group_id: 19,
    translate: 'configuration.onBoarding.additionalServices',
  },
  {
    title: 'Workflow Configuration',
    _id: 20,
    config_id: 'loose_bbx',
    group_id: 20,
    translate: 'configuration.onBoarding.workflowConfiguration',
  },
  // { title: 'Label Print Configuration', _id: 21, config_id: 'label_print_config', group_id: 21 },
  {
    title: 'Baby Default Options',
    _id: 22,
    config_id: 'baby_default_options',
    group_id: 22,
    translate: 'configuration.onBoarding.babyDefaultOptions',
  },
  {
    title: 'Pickup Default Setting',
    _id: 23,
    config_id: 'pickup_default_settings',
    group_id: 23,
    translate: 'configuration.onBoarding.pickupDefaultSetting',
  },
  {
    title: 'Report Configuration',
    _id: 24,
    config_id: 'report_configurations',
    group_id: 24,
    translate: 'configuration.onBoarding.reportConfiguration',
  },
  {
    title: 'Shipment Save Reciever Address',
    _id: 25,
    config_id: 'save_reciever_address',
    group_id: 25,
    translate: 'configuration.onBoarding.shipmentRecieverSavedAddress',
  },
  {
    title: 'Auto Generate Labels',
    _id: 26,
    config_id: 'auto_print_labels',
    group_id: 26,
    translate: 'configuration.onBoarding.shipmentAutoGenerateLabels',
  },
  {
    title: 'Account Numbers',
    itemTitle: 'Individual Ship Account Details',
    _id: 27,
    config_id: 'individualShip_accountnumbers',
    group_id: 3,
    group_title: 'Account Number',
    translate: 'configuration.onBoarding.accountNumbers',
  },
  {
    title: 'Individual Shipment Export Declaration Details',
    _id: 28,
    config_id: 'individualShipment_exportdeclarationdetails',
    group_id: 28,
    translate: 'configuration.onBoarding.individualShipmentExportDeclarationDetails',
  },
];

const validForShipmentLineItemsFormatMessage =
  'Invalid file format. Supported file formats allowed are TXT or CSV';

const validForCIFormatMessage =
  'Invalid file format. Supported file formats allowed are PDF, JPEG, GIF, PNG or TIFF';

const validForAddressFormatMessage = 'Invalid file format. Supported file format allowed is CSV';

const validForCISizeMessage = 'Maximum allowed file size is 5MB';
const validForSISizeMessage = 'Maximum allowed file size is 250KB';

const bbxTypes = [
  {
    label: 'Consolidated BBX',
    value: 'No',
  },
  {
    label: 'Loose BBX',
    value: 'Yes',
  },
];
const labelPrintTypes = [
  {
    label: 'Piece Level',
    value: 'Yes',
  },
  {
    label: 'Shipment Level',
    value: 'No',
  },
];

enum DGPackage {
  DryIce = 901,
  BiologicalSubstance = 650,
}

export {
  packageTypes,
  currencyValues,
  lineQuantityMisurements,
  lineItemReasonTypes,
  lineItemRefs,
  countryReference,
  fileUploadStatusDisplayedColumns,
  inCoTerms,
  exportInvoice,
  imageDocTemplates,
  exportReasonValues,
  paperTradeList,
  uoms,
  typeCode,
  fileUploadTypeCodeDisplayedColumns,
  configurationPageList,
  onBoarding,
  validForShipmentLineItemsFormatMessage,
  validForCIFormatMessage,
  validForAddressFormatMessage,
  validForCISizeMessage,
  bbxTypes,
  labelPrintTypes,
  validForSISizeMessage,
  incotermNames,
  placesofIncotermList,
  addressType,
  addressFileUploadStatusDisplayedColumns,
  reportTypes,
  reportFormat,
  DGPackage,
};
